var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"step2 step2active question error active\"><h2>Verify Your Identity with {{ vendor_name }}</h2><img src=\"{{ fail_svg }}\" width=\"130\" alt=\"\" style=\"margin: 30px auto;\"><h2>{{ vendor_name }} couldn't verify your identity!</h2><p ng-if=\"context == 'applicant'\">Please continue and submit your payment, then send us an email at&nbsp;<a href=\"\">{{SUPPORT_EMAIL}}</a>&nbsp;to verify your account for credit reports.</p><div class=\"cf\"></div><a href=\"#\" ng-if=\"context == 'applicant'\" ng-click=\"continue_app()\" class=\"create btn_next apply-next-step8\">Continue</a><a href=\"#\" ng-if=\"context == 'landlord'\" ng-click=\"continue()\" class=\"create btn_next apply-next-step8\">{{ $root.stored_form_data ? 'Return to Select Reports': 'Return to Dashboard' }}</a></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./components/verifications/fail/fail.jade
// module id = 1127
// module chunks = 0